import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'Components/Globals/Elements/Button';
import routes from 'Pages/router/constants/routes';
import { composeClassNames } from 'Helpers';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

const ConfirmExitModal = ({ onClose }) => {
	const { formatMessage } = useContent();
	const navigate = useNavigate();

	return (
		<div>
			<p className={composeClassNames(['m-16 sm', styles.description])}>
				{formatMessage(strings.firstDescription)}
				<br />
				{formatMessage(strings.secondDescription)}
			</p>
			<div className={styles.wrapper_button}>
				<Button
					label={formatMessage(strings.dismissButton)}
					onClick={() => onClose()}
					className={styles.wrapper_button__action}
					variant='outline'
					color='neutral'
				/>
				<Button
					label={formatMessage(strings.exitButton)}
					onClick={() => navigate(routes.dashboard)}
					className={styles.wrapper_button__action}
				/>
			</div>
		</div>
	);
};

export default ConfirmExitModal;
